import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=ca909fd4&scoped=true"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"
import style0 from "./Gifts.vue?vue&type=style&index=0&id=ca909fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca909fd4",
  null
  
)

export default component.exports